import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=fa65bdf6&scoped=true&"
import script from "./BookingTable.vue?vue&type=script&lang=js&"
export * from "./BookingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa65bdf6",
  null
  
)

export default component.exports